import { AxiosInstance } from 'axios';
import { AdministratorsRepository } from '@/model/repository/manager/administrators/AdministratorsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AdministratorsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
